/**
 * Default earliest effective date for the distribution batches filter.
 * This is set to Feb 1, 2026 as per ticket FF-6205.
 * TODO: Update this date upon M1 release.
 */
export const DEFAULT_EARLIEST_EFFECTIVE_DATE = "2026-02-01";
